import { useEffect, useState } from "react";
import axios from "../../../axios"; // Adjust the import path as necessary
import { Link } from "react-router-dom";
import formatCurrency from "../../../utils/formatCurrency";

export default function OrderListPage() {
    const [orders, setOrders] = useState([]);
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);


    useEffect(() => {
        // axios.get("/admin/orders").then((res) => setOrders(res.data));
        axios.get(`/admin/orders?page=${page}`).then((res) => {
            setOrders(res.data.data);
            setMeta(res.data.meta || res.data); // jika pakai resource
        });
    }, [page]);

    function StatusBadge({ status }) {
        let color = "secondary";
        let label = status;
        switch (status) {
            case "pending":
                color = "warning";
                label = "Pending";
                break;
            case "paid":
                color = "info";
                label = "Paid";
                break;
            case "verified":
                color = "success";
                label = "Verified";
                break;
            case "canceled":
                color = "danger";
                label = "Canceled";
                break;
            default:
                color = "secondary";
        }
        return (
            <span className={`badge bg-${color} text-capitalize`}>
                {label}
            </span>
        );
    }

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-4">Daftar Pesanan</h4>
            </div>

            <div className="card-body">
                <table className="table table-lg table-striped w-100">
                    <thead>
                        <tr>
                            <th className="h6 text-gray-600 text-center">Order ID</th>
                            <th className="h6 text-gray-600 text-center">Produk</th>
                            <th className="h6 text-gray-600 text-center">Customer</th>
                            <th className="h6 text-gray-600 text-center">Amount</th>
                            <th className="h6 text-gray-600 text-center">Status</th>
                            <th className="h6 text-gray-600 text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((o) => (
                            <tr key={o.id}>
                                <td className="text-center">
                                    <span className="text-gray-600">
                                        {String(o.id).substring(0, 8).toUpperCase()}
                                    </span>
                                </td>
                                <td className="text-center">
                                    <span className="text-gray-600">
                                        {o.product?.name}
                                    </span>
                                </td>
                                <td className="text-center">
                                    <span className="text-gray-600">
                                        {o.user?.name}
                                    </span>
                                </td>
                                <td className="text-center">
                                    <span className="text-gray-600">
                                        {formatCurrency(parseInt(o.price_total) + parseInt(o.unique_code) - parseInt(o.price_disc))}
                                    </span>
                                </td>
                                <td className="text-center"><StatusBadge status={o.status} /></td>
                                <td>
                                    <Link to={`/admin/orders/${o.id}`} className="btn btn-sm btn-primary">
                                        Detail
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="d-flex justify-content-center mt-3">
                    {Array.from({ length: meta.last_page || 1 }).map((_, i) => (
                        <button
                            key={i}
                            className={`btn btn-sm mx-1 ${meta.current_page === i + 1 ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setPage(i + 1)}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>

            </div>
        </div>
    );
}
